<template>
  <li style="display: list-item;">
    <!-- <div class="nex_topbards nex_topbards3"></div> -->
    <div class="nex_aboutusbx">
      <div class="nex_about_title">
        <h1><span>企业资质</span></h1>
      </div>
      <div class="nex_baodao">
        <dl>
          <!--[diy=nex_baodao]-->
          <div id="nex_baodao" class="area">
            <div id="frameZLxAOi" class="frame move-span cl frame-1">
              <div id="frameZLxAOi_left" class="column frame-1-c">
                <div id="frameZLxAOi_left_temp" class="move-span temp"></div>
                <div id="portal_block_107" class="block move-span">
                  <div id="portal_block_107_content" class="dxb_bc">
                    <!-- <dd @mouseover="selectStyle" :class="{'active':active}" @mouseout="outStyle"> -->
                    <!-- 	<div class="nex_bdpic">
												<a href="" target="_blank"><img src="https://www.mools.net/lims/web/OfficialWebsite/images/9.jpg"
													 width="360" height="250"></a>
											</div> -->
                    <!-- 	<div class="nex_bdinter">
												<h5><a href="portal.php?mod=view&amp;aid=16" target="_blank">苹果无线充电、微软新款平板...2018最值得</a></h5>
												<p>2017年已经过去，2018年刚刚开始。这意味着，在这新的一年里，我们将会看到更多全新科</p>
											</div> -->
                    <!-- <div class="nex_bdbtms">
												<div class="nex_bdsdl">来自：企业新闻</div>
												<div class="nex_bdbtmr">
													<span class="nex_bdbtmrv">166</span>
													<span class="nex_bdbtmrd">08-03</span>
													<div class="clear"></div>
												</div>
												<div class="clear"></div>
											</div> -->
                    <!-- </dd> -->
                    <dd>
                      <div class="nex_bdpic">
                        <a href="" target="_blank"><img src="https://www.mools.net/lims/web/OfficialWebsite/images/9.jpg"
                            width="360" height="250"></a>
                      </div>

                    </dd>
                    <dd>
                      <div class="nex_bdpic">
                        <a href="" target="_blank"><img src="https://www.mools.net/lims/web/OfficialWebsite/images/10.jpg"
                            width="360" height="250"></a>
                      </div>

                    </dd>
                    <dd>
                      <div class="nex_bdpic">
                        <a href="" target="_blank"><img src="https://www.mools.net/lims/web/OfficialWebsite/images/12.jpg"
                            width="360" height="250"></a>
                      </div>

                    </dd>
                    <dd>
                      <div class="nex_bdpic">
                        <a href="" target="_blank"><img src="https://www.mools.net/lims/web/OfficialWebsite/images/13.jpg"
                            width="360" height="250"></a>
                      </div>

                    </dd>
                    <dd>
                      <div class="nex_bdpic">
                        <a href="" target="_blank"><img src="https://www.mools.net/lims/web/OfficialWebsite/images/14.jpg"
                            width="360" height="250"></a>
                      </div>
                    
                    </dd>
                    <dd>
                      <div class="nex_bdpic">
                        <a href="" target="_blank"><img src="https://www.mools.net/lims/web/OfficialWebsite/images/15.jpg"
                            width="360" height="250"></a>
                      </div>
                    
                    </dd>
                    <dd>
                      <div class="nex_bdpic">
                        <a href="" target="_blank"><img src="https://www.mools.net/lims/web/OfficialWebsite/images/16.jpg"
                            width="360" height="250"></a>
                      </div>
                    
                    </dd>
                    <dd>
                      <div class="nex_bdpic">
                        <a href="" target="_blank"><img src="https://www.mools.net/lims/web/OfficialWebsite/images/17.jpg"
                            width="360" height="250"></a>
                      </div>
                    
                    </dd>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--[/diy]-->

          <div class="clear"></div>
        </dl>
      </div>
    </div>
  </li>
</template>

<script>
  export default {
    name: 'index',
    data() {
      return {
        active: false,
      }
    },

    methods: {
      selectStyle() {
        this.active = true;
      },
      outStyle() {
        this.active = false;
      }
    }
  }
</script>

<style scoped="scoped">
  .active {
    transform: translateY(-8px);
    box-shadow: 0 0px 23px 0 rgba(7, 17, 27, .3);
  }

  .nex_topbards3 {
    background: url(http://www.mools.net/lims/web/OfficialWebsite/about/bgnew.png) center no-repeat;
  }

  .nex_topbards {
    height: 200px;
    width: 924px;
    background: url(http://www.mools.net/lims/web/OfficialWebsite/about/bgnew.png) center no-repeat;
    position: relative;
  }

  .nex_aboutusbx {
    border-radius: 4px;
    width: 864px;
    background: #fff;
    overflow: hidden;
    position: relative;
    z-index: 3;
    padding: 30px;
  }

  .nex_about_title h1 {
    border-left: 6px solid #0095FF;
    padding-left: 15px;
    font-size: 18px;
    color: #333;
    font-weight: 500;
    height: 20px;
    line-height: 20px;
    margin-bottom: 20px;
  }

  .nex_baodao {
    margin-top: 30px;
  }

  .nex_baodao dl {
    width: 890px;
  }

  .move-span {
    background: none;
  }

  .move-span {
    background-image: none !important;
    border: 0 none !important;
    margin: 0 !important;
    padding: 0 !important;
    border-width: 0px;
    height: auto;
  }

  .frame-1 {
    background-color: transparent !important;
    background-image: none !important;
    border: 0 none !important;
    margin: 0 !important;
    padding: 0 !important;
    border-width: 0px;
    height: auto;
  }

  .frame,
  .frame-tab {
    margin-bottom: 10px;
    border: 1px solid #ededed;
    background: #FFF;
  }

  .cl {
    zoom: 1;
  }

  .frame-1-c {
    background-color: transparent !important;
    background-image: none !important;
    border: 0 none !important;
    margin: 0 !important;
    padding: 0 !important;
    border-width: 0px;
    height: auto;
  }

  .nex_baodao dl dd {
    float: left;
    width: 200px;
    background: #fff;
    border-radius: 4px;
    margin: 0 15px 15px 0;
    /* box-shadow: 0 0px 3px 0 rgba(7,17,27,.1); */
    -webkit-transition: all 0.3s linear;
    -moz-transition: all 0.3s linear;
    -o-transition: all 0.3s linear;
    -ms-transition: all 0.3s linear;
    transition: all 0.3s linear;
  }

  .nex_bdpic {
    width:200px;
    height:246px;
  }

  a {
    color: #333;
    text-decoration: none;
  }

  .nex_bdpic img {
    width: 200px;
    height: 246px;
  }

  a img {
    border: none;
  }

  .nex_bdinter {
    padding: 18px 20px;
    border-bottom: 1px solid #ededed;
  }

  .nex_bdinter h5 {
    display: block;
    height: 44px;
    line-height: 22px;
    overflow: hidden;
  }

  .nex_bdinter h5 a {
    font-size: 16px;
    color: #555;
    font-weight: 500;
    letter-spacing: 1px;
  }

  .nex_bdinter p {
    font-size: 12px;
    color: #999;
    margin-top: 10px;
    display: block;
    height: 34px;
    line-height: 17px;
    overflow: hidden;
  }

  .nex_bdbtms {
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
  }

  .nex_bdsdl {
    float: left;
    font-size: 12px;
    color: #999;
  }

  .nex_bdbtmr {
    float: right;
  }

  .nex_bdbtmr span.nex_bdbtmrv {
    background: url(http://www.mools.net/lims/web/OfficialWebsite/about/view.png) left center no-repeat;
    padding-left: 25px;
  }

  .nex_bdbtmr span {
    display: inline-block;
    margin-left: 10px;
    font-size: 12px;
    color: #999;
  }

  .nex_bdbtmr span.nex_bdbtmrd {
    background: url(http://www.mools.net/lims/web/OfficialWebsite/about/date.png) left center no-repeat;
    padding-left: 23px;
  }

  .clear {
    clear: both;
  }
</style>



// WEBPACK FOOTER //
// src/components/about/MediaReport.vue